/**
 * Translates the jQuery datepicker widget prev/next labels as they could not be found using
 * string translation in WPML. Months and weekdays are fine, just these buttons seem to be missing.
 *
 * The 'datepicker_prev' and 'datepicker_next' strings are manually registered in 'gravityforms'
 * domain and then passed to JS_GLOBALS when loading the main JS.
 * Please see functions/gravity-forms.php for the registration functions.
 */
window.jQuery(document).ready(function($) {
  // Check if datepicker is available
  if ($.fn.datepicker) {
    $.extend($.datepicker.regional[''], {
      prevText: window.JS_GLOBALS['wpml']['datepicker_prev'],
      nextText: window.JS_GLOBALS['wpml']['datepicker_next']
    });
    $.datepicker.setDefaults($.datepicker.regional['']);
  }
});